import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, HostListener, inject, Input, ViewChild } from '@angular/core';
import { DeviceService } from '../../../shared/services/device.service';
import { StickyLink } from '../../../admin/shared/public-api';

@Component({
  selector: 'app-sticky-links',
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './sticky-links.component.html',
  styleUrl: './sticky-links.component.scss',
})
export class StickyLinksComponent {
  @Input({ required: true }) stickyLinks: StickyLink[];
  @Input({ required: true }) title: string;
  @ViewChild('stickyLinkWrapper') wrapper: ElementRef;

  protected deviceService = inject(DeviceService);
  showSticky: boolean;

  scrollListener: any;

  @HostListener('window:scroll')
  @HostListener('window:resize')
  onScroll(): void {
    this.showSticky = !this.isInViewport(this.wrapper.nativeElement) && window.innerWidth > 1700;
  }

  private isInViewport(elm: HTMLElement): boolean {
    const { top, height } = elm.getBoundingClientRect();
    const bottom = top + height - 90; // 90 is the height of the nav
    return bottom > 0;
  }
}
